import { useNavigate } from 'react-router';

import PosTerminalIcon from '~domains/partner-application/shared/assets/icons/pos-terminal.svg?react';
import { getApplicationEventProperties } from '~domains/partner-application/shared/lib';
import { StatusScreenContent } from '~domains/partner-application/shared/ui/status-screen-content';

import { ampli } from '~shared/analytics';
import { ROUTES } from '~shared/config/routes';
import { Screen } from '~shared/ui/screen';

import { PartnerApplicationMenuHeader } from '../../partner-application-menu-header';

type NewApplicationScreenProps = {
  applicationId: string;
};

export const NewApplicationScreen = ({
  applicationId,
}: NewApplicationScreenProps) => {
  const navigate = useNavigate();

  return (
    <Screen header={<PartnerApplicationMenuHeader />}>
      <StatusScreenContent
        icon={<PosTerminalIcon />}
        title={
          <>
            You&#39;re almost done,{' '}
            <span className="text-skyro-blue">boss!</span>
          </>
        }
        description={
          <>
            Share the&nbsp;other&nbsp;details to&nbsp;complete
            your&nbsp;application.
          </>
        }
        action={{
          label: 'Finish application',
          onClick: () => {
            ampli.mpPaFinishApplicationClick(
              getApplicationEventProperties(applicationId)
            );
            navigate(ROUTES.partner.applicationEdit.link(applicationId));
          },
        }}
      />
    </Screen>
  );
};
